export default function initAccordion() {
  const accordionItems = document.querySelectorAll(".accordion_item");

  accordionItems.forEach((item) => {
    const title = item.querySelector(".accordion_title");
    
    if (title) {
      title.addEventListener("click", () => {
        const isActive = item.classList.contains("active");

        // Close all other items
        accordionItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.remove("active");
          }
        });

        // Toggle current item
        item.classList.toggle("active");
      });
    }
  });
}
